<template>
  <header class="header-authenticate">
    <div class="container">
      <div class="header-authenticate__back" v-if="visible" @click="goBack">
        <img src="@/assets/chevron.svg" alt="">
      </div>
      <div class="header-authenticate__logo">
        <img src="@/assets/superliga/logo-1x.png" alt="" v-if="$config.MODE == 'SUPERLIGA'">
        <img src="@/assets/isologo.svg" alt="" v-else>
      </div>
      <div class="header-authenticate__profile" @click="goToProfile">
        <template v-if="this.profile.picture && this.profile.picture != ''">
          <img :src="getUrlProfile()">
        </template>
        <template v-else>
          <h3>{{getName()}}</h3>
        </template>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      visible: false
    }
  },
  computed: {
    ...mapState({
      profile: state => state.ProfileModule.profile
    })
  },
  created() {
    this.visible = this.$route.path != '/home/games'
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goToProfile() {
      if(this.$route.path != '/profile') this.$router.push('/profile')
    },
    getUrlProfile() {
      if (this.profile.picture) {
        return `${process.env.VUE_APP_CDN_URL_USER}${this.profile.picture}`
      }
    },
    getName() {
      if (this.profile.firstName && this.profile.lastName) {
        return `${this.profile.firstName.charAt(0)}${this.profile.lastName.charAt(0)}`
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.header-authenticate {
  width: 100%;
  position: fixed;
  top: 0;
  padding: $margin-base;
  color: $white;
  z-index: 2;
  background: linear-gradient($darkblue, #21012b00);

  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    @media (min-width: $break-lg) {
      height: $margin-tera;
    }
  }

  &__back {
    left: 0;
    position: absolute;
    padding: $margin-base;
    cursor: pointer;
  }

  &__profile {
    width: $margin-mega;
    height: $margin-mega;
    background: $white;
    border-radius: 50%;
    position: absolute;
    right: 0;
    cursor: pointer;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (min-width: $break-lg) {
      width: $margin-tera;
      height: $margin-tera;
    }

    h3 {
      color: $dark;
      font-weight: bold;
      
    }
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__logo {
    height: $margin-mega;
    
    img {
      height: $margin-mega;
    }
  }
}
</style>